import Vue from 'vue'
import App from './App.vue'
// 123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890123456789012345678901234567890
// JOHAN@POWERPROP.CO.ZA                                                                                                                                 1234


Vue.config.productionTip = false

Vue.mixin({
  data: function() {
    return {
      get apihost() {
        return "https://mamela.ddns.net/pp/";
        // return "http://localhost:81/pp/";
      }
    }
  }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
